import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader,} from 'reactstrap';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {useStoreActions, useStoreState} from '../../store/hooks';
import {DeclineAndClose, SwitchContainer, SwitchLabel,} from './CookiesModal.style';

/* Translations */

const translateTitle = <FormattedMessage id="cookies.title" />;
const translateClose = <FormattedMessage id="cookies.close" />;
const translateDescription = <FormattedMessage id="cookies.description" />;
const translatePersonalize = <FormattedMessage id="cookies.personalize" />;
const translateAccept = <FormattedMessage id="cookies.accept" />;

const translatePreferences = <FormattedMessage id="cookies.preferences" />;
const translateNecessary = <FormattedMessage id="cookies.necessary" />;
const translateFunctionality = <FormattedMessage id="cookies.functionality" />;
const translateSave = <FormattedMessage id="cookies.save" />;
const translateAcceptAll = <FormattedMessage id="cookies.acceptAll" />;

/* ************ */

const CookiesModal = NiceModal.create(() => {

  const modal = useModal();

  const isOptionalCookiesConsent = useStoreState(
    state => state.cookies.optionalCookiesConsent,
  );
  const isCookiesSeen = useStoreState(state => state.cookies.cookiesSeen);

  const setCookiesSeen = useStoreActions(
    actions => actions.cookies.setCookiesSeen,
  );
  const setOptionalCookiesConsent = useStoreActions(
    actions => actions.cookies.setOptionalCookiesConsent,
  );

  const [isPreferences, setIsPreferences] = useState(false);
  const [acceptFunctionality, setAcceptFunctionality] = useState(
    isCookiesSeen ? isOptionalCookiesConsent : true,
  );

  function closeModal(optionalCookiesConsent: boolean) {
    modal.remove();
    setCookiesSeen(true);
    setOptionalCookiesConsent(optionalCookiesConsent);
  }

  const declineCookies = () => {
    closeModal(false);
  };

  const acceptCookies = () => {
    closeModal(acceptFunctionality);
  };

  const acceptAllCookies = () => {
    closeModal(true);
  };

  const PreferenceCookiesModal = (): React.JSX.Element => (
    <>
      <ModalHeader>
        {translatePreferences}
      </ModalHeader>
      <ModalBody>
        <SwitchContainer>
          <SwitchLabel>{translateNecessary}</SwitchLabel>
          <div className="form-check form-check-sm form-switch">
            <input
              type="checkbox"
              role='switch'
              className='form-check-input'
              id="necessaryCookiesSwitch"
              defaultChecked
              readOnly
              disabled
            />
          </div>
        </SwitchContainer>
        <SwitchContainer>
          <SwitchLabel>{translateFunctionality}</SwitchLabel>
          <div className="form-check form-check-sm form-switch">
            <input
              type="checkbox"
              role='switch'
              className='form-check-input'
              id="OptionalCookiesSwitch"
              checked={acceptFunctionality}
              onChange={() => setAcceptFunctionality(!acceptFunctionality)}
            />
          </div>
        </SwitchContainer>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={acceptAllCookies}>
          {translateAcceptAll}
        </Button>{' '}
        <Button color="secondary" onClick={() => setIsPreferences(false)}>
          {translateSave}
        </Button>
      </ModalFooter>
    </>
  );

  const DefaultCookiesModal = (): React.JSX.Element => (
    <>
      <ModalHeader close={(
        <DeclineAndClose onClick={declineCookies}>
          {translateClose}
        </DeclineAndClose>
      )}>
        {translateTitle}
      </ModalHeader>
      <ModalBody>
        {translateDescription}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setIsPreferences(true)}>
          {translatePersonalize}
        </Button>{' '}
        <Button color="primary" onClick={acceptCookies}>
          {translateAccept}
        </Button>
      </ModalFooter>
    </>
  );

  return (
    <Modal isOpen={modal.visible} onClosed={() => {
      console.log("closed");
      modal.remove();
    }}>
      {isPreferences ? <PreferenceCookiesModal /> : <DefaultCookiesModal />}
    </Modal>
  )
});

export default CookiesModal;
